export const WALLET_LINKING_SET_RETAIL_CARD_NUMBER = 'WALLET_LINKING:RETAIL_CARD_NUMBER:SET';
export const WALLET_LINKING_SET_OPEN_URL = 'WALLET_LINKING:OPEN_URL:SET';
export const WALLET_LINKING_SET_DOCUMENT_DATA = 'WALLET_LINKING:DOCUMENT_DATA:SET';
export const WALLET_LINKING_SET_PLAYER_DATA = 'WALLET_LINKING:PLAYER_DATA:SET';
export const WALLET_LINKING_SET_PIN = 'WALLET_LINKING:PIN:SET';

export const setRetailCardNumber = (retailCardNumber) => ({
    type: WALLET_LINKING_SET_RETAIL_CARD_NUMBER,
    payload: retailCardNumber
});

export const setOpenUrl = (openUrl) => ({
    type: WALLET_LINKING_SET_OPEN_URL,
    payload: openUrl
});

export const setPin = (pin) => ({
    type: WALLET_LINKING_SET_PIN,
    payload: pin
});

export const setDocumentData = (documentData) => ({
    type: WALLET_LINKING_SET_DOCUMENT_DATA,
    payload: documentData
});

export const setPlayerData = (playerData) => ({
    type: WALLET_LINKING_SET_PLAYER_DATA,
    payload: playerData
});
